"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PaginationTable_1 = require("../PaginationTable");
var react_1 = require("react");
var customer_1 = require("../../api/customer");
var EditLicenseButton_1 = require("./modals/EditLicenseButton");
var EditServiceButton_1 = require("./modals/EditServiceButton");
var ChangeTierButton_1 = require("./modals/ChangeTierButton");
var msal_react_1 = require("@azure/msal-react");
var msal_browser_1 = require("@azure/msal-browser");
var authConfig_1 = require("../../authConfig");
require("../../styles/SubscriptionListPage.css");
var AddNewLicense_1 = require("./modals/AddNewLicense");
var AddNewService_1 = require("./modals/AddNewService");
var graph_1 = require("../../graph");
var LicenseDeleteButton_1 = require("./modals/LicenseDeleteButton");
var ServiceDeleteButton_1 = require("./modals/ServiceDeleteButton");
var handleEdit = function (row) { };
var handleDelete = function (row) { };
var CustomerSubscriptionListPage = function (props) {
    var authRequest = __assign({}, authConfig_1.loginRequest);
    var inProgress = (0, msal_react_1.useMsal)().inProgress;
    var _a = (0, react_1.useState)({ id: "" }), graphData = _a[0], setGraphData = _a[1];
    var _b = (0, react_1.useState)(''), userId = _b[0], setUserId = _b[1];
    var _c = (0, react_1.useState)(0), companyId = _c[0], setCompanyId = _c[1];
    var _d = (0, react_1.useState)({
        purchasedLicenses: new Array()
    }), company = _d[0], setCompany = _d[1];
    var _e = (0, msal_react_1.useMsal)(), instance = _e.instance, accounts = _e.accounts;
    var _f = (0, react_1.useState)(false), isAuthorizedSuperAdmin = _f[0], setIsAuthorizedSuperAdmin = _f[1];
    var _g = (0, react_1.useState)(false), isLoaded = _g[0], setIsLoaded = _g[1];
    var _h = (0, react_1.useState)(new Array()), licenseData = _h[0], setLicenseData = _h[1];
    var _j = (0, react_1.useState)(new Array()), supportData = _j[0], setSupportData = _j[1];
    var _k = (0, react_1.useState)(new Array()), serviceData = _k[0], setServiceData = _k[1];
    var updateLicenseDataCallBack = function (purchasedLicense) {
        var newLicenseData = licenseData.map(function (item) {
            if (item.id == purchasedLicense.purchasedLicenseId) {
                item.unit = purchasedLicense.unit;
            }
            return item;
        });
        setLicenseData(__spreadArray([], newLicenseData, true));
        setIsLoaded(false);
    };
    var deleteLicenseDataCallBack = function () {
        var id = 1;
        if (props.id) {
            id = props.id;
            setCompanyId(id);
        }
        (0, customer_1.fetchCustomer)(id.toString()).then(function (data) {
            setLicenseData(data.purchasedLicenses
                .map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedLicenseId,
                    licenseId: item.licenseId,
                    name: item.license.name,
                    unit: item.unit,
                };
            }));
            setSupportData(data.purchasedLicenses.map(function (item) {
                return {
                    companyId: id,
                    id: item.support.supportId,
                    name: item.support.name,
                    scale: item.support.scale,
                    tier: item.support.tier
                };
            }));
        });
    };
    var updateServiceDataCallBack = function (pServiceId, name) {
        var newServiceData = serviceData.map(function (item) {
            if (item.purchasedServiceId == pServiceId) {
                item.name = name;
            }
            return item;
        });
        setServiceData(__spreadArray([], newServiceData, true));
    };
    var deleteServiceDataCallBack = function () {
        var id = 1;
        if (props.id) {
            id = props.id;
            setCompanyId(id);
        }
        (0, customer_1.fetchCustomer)(id.toString()).then(function (data) {
            setServiceData(data.purchasedServices
                .map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedServiceId,
                    serviceId: item.serviceId,
                    purchasedServiceId: item.purchasedServiceId,
                    name: item.service.name,
                };
            }));
        });
    };
    var updateSupportDataCallBack = function (response) {
        var newSupportData = supportData.map(function (item) {
            if (item.supportId == response.supportId) {
                item.tier = response.tier.charAt(0).toUpperCase() + response.tier.slice(1);
            }
            return item;
        });
        setSupportData(__spreadArray([], newSupportData, true));
    };
    var licenseListColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Unit',
            accessor: 'unit'
        },
        {
            Header: 'Action',
            accessor: 'id',
            Cell: function (row) {
                return React.createElement("div", { className: "license-action" }, [
                    React.createElement(EditLicenseButton_1.default, { id: row.value, list: licenseData, userId: graphData.id, modalCallback: updateLicenseDataCallBack }, null),
                    React.createElement(LicenseDeleteButton_1.default, { id: row.value, list: licenseData, userId: graphData.id, modalCallback: deleteLicenseDataCallBack }, null)
                ]);
            }
        }
    ];
    var supportListColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Scale',
            accessor: 'scale'
        },
        {
            Header: 'Tier',
            accessor: 'tier'
        },
        {
            Header: 'Action',
            accessor: 'id',
            //Cell: (row: any) => (
            //    <div className="support-action">
            //        <ChangeTierButton id={row.value} userId={graphData.id} />
            //    </div>
            //    )
            Cell: function (row) {
                return React.createElement("div", { className: "support-action" }, React.createElement(ChangeTierButton_1.default, { id: row.value, list: supportData, userId: graphData.id, supportModalCallback: updateSupportDataCallBack }, null));
            }
        }
    ];
    var serviceListColumns = [
        {
            Header: 'Name',
            accessor: 'name'
        },
        {
            Header: 'Action',
            accessor: 'id',
            Cell: function (row) {
                return React.createElement("div", { className: "service-action" }, [
                    React.createElement(EditServiceButton_1.default, { id: row.value, list: serviceData, userId: graphData.id, modalCallback: updateServiceDataCallBack }, null),
                    React.createElement(ServiceDeleteButton_1.default, { id: row.value, list: serviceData, userId: graphData.id, modalCallback: deleteServiceDataCallBack }, null)
                ]);
            }
        }
    ];
    var licenseColumns = licenseListColumns;
    var supportColumns = supportListColumns;
    var serviceColumns = serviceListColumns;
    var pushToLicenseData = function (item) {
        /*setLicenseData([{ ...licenseData }, ...item]);*/
        /*setLicenseData([...new Array<any>()]);*/
        var id = 1;
        if (props.id) {
            id = props.id;
            setCompanyId(id);
        }
        (0, customer_1.fetchCustomer)(id.toString()).then(function (data) {
            setLicenseData(data.purchasedLicenses
                .map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedLicenseId,
                    licenseId: item.licenseId,
                    name: item.license.name,
                    unit: item.unit,
                };
            }));
            setSupportData(data.purchasedLicenses.map(function (item) {
                return {
                    companyId: id,
                    id: item.support.supportId,
                    name: item.support.name,
                    scale: item.support.scale,
                    tier: item.support.tier
                };
            }));
        });
    };
    var pushToServiceData = function (item) {
        /*setServiceData([{ ...serviceData }, ...item]);*/
        var id = 1;
        if (props.id) {
            id = props.id;
            setCompanyId(id);
        }
        (0, customer_1.fetchCustomer)(id.toString()).then(function (data) {
            setServiceData(data.purchasedServices
                .map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedServiceId,
                    serviceId: item.serviceId,
                    purchasedServiceId: item.purchasedServiceId,
                    name: item.service.name,
                };
            }));
        });
    };
    var onLoad = function () {
        requestProfileData();
        var id = 1;
        if (props.id) {
            id = props.id;
            setCompanyId(id);
        }
        (0, customer_1.fetchCustomer)(id.toString()).then(function (data) {
            setLicenseData(data.purchasedLicenses
                .map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedLicenseId,
                    licenseId: item.licenseId,
                    name: item.license.name,
                    unit: item.unit,
                };
            }));
            setServiceData(data.purchasedServices.map(function (item) {
                return {
                    companyId: id,
                    id: item.purchasedServiceId,
                    serviceId: item.serviceId,
                    purchasedServiceId: item.purchasedServiceId,
                    name: item.service.name
                };
            }));
            setSupportData(data.purchasedLicenses.map(function (item) {
                return {
                    companyId: id,
                    id: item.support.supportId,
                    name: item.support.name,
                    scale: item.support.scale,
                    tier: item.support.tier
                };
            }));
            setIsLoaded(true);
        }).catch(console.error);
    };
    var requestProfileData = function () {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent(__assign(__assign({}, authConfig_1.loginRequest), { account: accounts[0] })).then(function (response) {
            (0, graph_1.callMsGraph)("GET", response.accessToken, authConfig_1.graphConfig.graphMeEndpoint).then(function (response) {
                setGraphData(response);
                setUserId(response.id);
            });
        });
    };
    var checkIfSuperAdmin = function () {
        var currentAccount = instance.getActiveAccount();
        if (currentAccount && currentAccount.idTokenClaims) {
            var tokenClaims = currentAccount.idTokenClaims['roles'];
            console.log('token');
            console.log(tokenClaims);
            var intersection = tokenClaims.includes(authConfig_1.appRoles.SuperAdmin);
            if (intersection) {
                setIsAuthorizedSuperAdmin(true);
            }
        }
    };
    (0, react_1.useEffect)(function () {
        if (!isLoaded && inProgress === msal_browser_1.InteractionStatus.None) {
            onLoad();
        }
    }, [instance, inProgress, licenseData, setLicenseData, supportData, setSupportData, serviceData, setServiceData, isLoaded]);
    return (React.createElement(React.Fragment, null,
        React.createElement(msal_react_1.MsalAuthenticationTemplate, { interactionType: msal_browser_1.InteractionType.Redirect, authenticationRequest: authRequest },
            React.createElement("h5", { className: "padding-default card-title subscriptionTitle" }, "Sofftware License"),
            React.createElement("div", { className: "SubcriptionAddButton", id: "NewLicenseButton" },
                React.createElement(AddNewLicense_1.default, { companyId: companyId, userId: graphData.id, callback: pushToLicenseData.bind(_this) })),
            React.createElement("div", { className: "tableContainer  borderlessContainer", id: "licenseTable" }, licenseData ? React.createElement(PaginationTable_1.PaginationTable, { columns: licenseListColumns, data: licenseData }) : React.createElement(React.Fragment, null, "Loading...")),
            React.createElement("h5", { className: "padding-default card-title subscriptionTitle" }, "Support"),
            React.createElement("div", { className: "tableContainer borderlessContainer", id: "supportTable" }, supportData ? React.createElement(PaginationTable_1.PaginationTable, { columns: supportListColumns, data: supportData }) : React.createElement(React.Fragment, null, "Loading...")),
            React.createElement("h5", { className: "padding-default card-title subscriptionTitle" }, "Service"),
            React.createElement("div", { className: "SubcriptionAddButton", id: "NewServiceButton" },
                React.createElement(AddNewService_1.default, { companyId: companyId, userId: graphData.id, callback: pushToServiceData.bind(_this) })),
            React.createElement("div", { className: "tableContainer borderlessContainer" }, serviceData ? React.createElement(PaginationTable_1.PaginationTable, { columns: serviceListColumns, data: serviceData }) : React.createElement(React.Fragment, null, "Loading...")))));
};
exports.default = CustomerSubscriptionListPage;
//# sourceMappingURL=CustomerSubscriptionListPage.js.map